module.exports = __webpack_public_path__ + "static/media/two-active-people.ba99145e.webp";